<template>
    <plain-layout :isPlain="true" :showTerms="false">
        <div>
            <common-page-header class="connections__header" :heading="pageTitle">
                <template #right>
                    <common-button
                        v-if="!showReferralHistory"
                        :label="$t('pages.network.ehr.view_history')"
                        type="secondary"
                        size="small"
                        @click="openReferralHistory"
                    ></common-button>
                    <common-button
                        v-else
                        :label="$t('pages.network.ehr.back_to_network')"
                        type="secondary"
                        size="small"
                        @click="closeReferralHistory"
                    ></common-button>
                </template>
            </common-page-header>
            <common-content-spacer height="small">
                <ehr-referral-pool-history v-if="showReferralHistory"></ehr-referral-pool-history>
                <common-tabs v-else :tabs="tabs" :activeTab="tabs[0].name" @tab-click="tabChange($event)">
                    <template v-slot:physicians>
                        <provider-table-filter @filter-changed="filterChanged"></provider-table-filter>
                        <provider-table :filters="filters" :practiceType="practiceType"></provider-table>
                    </template>
                    <template v-slot:providers>
                        <provider-table-filter @filter-changed="filterChanged"></provider-table-filter>
                        <provider-table :filters="filters" :practiceType="practiceType"></provider-table>
                    </template>
                </common-tabs>
            </common-content-spacer>
        </div>
    </plain-layout>
</template>

<script>
    import PlainLayout from 'components/layouts/PlainLayout'
    import ProviderTable from 'components/page-elements/ehr/ProviderTable'
    import ProviderTableFilter from 'components/page-elements/ehr/ProviderTableFilter'
    import EhrReferralPoolHistory from 'components/page-elements/ehr/EhrReferralPoolHistory'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        mixins: [],

        components: {
            PlainLayout,
            ProviderTable,
            ProviderTableFilter,
            EhrReferralPoolHistory,
        },

        data() {
            return {
                PracticeTypeEnum: PracticeTypeEnum,
                practiceType: PracticeTypeEnum.PHYSICIAN,
                filters: null,
                showReferralHistory: false,
            }
        },

        computed: {
            tabs() {
                const tabs = [
                    {
                        name: 'physicians',
                        displayName: this.$t('pages.network.connections.tabs.physicians'),
                        icon: 'member-transparent',
                    },
                    {
                        name: 'providers',
                        displayName: this.$t('pages.network.connections.tabs.providers'),
                        icon: 'colleague-transparent',
                    },
                ]

                return tabs
            },

            pageTitle() {
                return this.$t('pages.network.ehr.header')
            },
        },

        methods: {
            openReferralHistory() {
                this.showReferralHistory = true
            },

            closeReferralHistory() {
                this.showReferralHistory = false
            },

            tabChange(tabName) {
                if (tabName === this.tabs[0].name) {
                    this.physiciansTabClicked()
                } else {
                    this.ancillaryTabClicked()
                }
            },

            physiciansTabClicked() {
                this.practiceType = PracticeTypeEnum.PHYSICIAN
            },

            ancillaryTabClicked() {
                this.practiceType = PracticeTypeEnum.ANCILLARY
            },

            filterChanged(payload) {
                this.filters = payload
            },
        },

        mounted() {},
    }
</script>

<style lang="scss">
    .ehr {
    }
</style>
